import { render, staticRenderFns } from "./GerenciadorResultadosItem.vue?vue&type=template&id=c3541cb0&"
import script from "./GerenciadorResultadosItem.vue?vue&type=script&lang=js&"
export * from "./GerenciadorResultadosItem.vue?vue&type=script&lang=js&"
import style0 from "./GerenciadorResultadosItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports